
import styles from '../style.module.css';
import lang from "../../../lang/lang";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function Members({ image, title }) {

    const { currentLanguage } = useSelector(({ main }) => main);
    const navigate = useNavigate();

    return (
        <div className={styles.members_section}>
            <div className={styles.members_foto}>
                <img
                    src={image}
                    alt = { 'vlv team photo' }
                />
            </div>
            <div className={styles.members_text_link_content}>
                <h2> { title } </h2>
                <button
                    className={styles.members_link}
                    onClick={() => navigate('/job')}
                >
                    { lang[currentLanguage].view_more }
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
                        <path d="M0.750037 0.75L5.25 5.25002L0.75 9.75002" stroke="#282828" strokeWidth="1.5" strokeMiterlimit="16" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default Members